<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="1280"
    style="overflow-y: hidden !important"
  >
    <v-card style="overflow-y: hidden !important">
      <v-card-title class="primary"
        ><span class="white--text">Consultar producto</span>
        <v-spacer></v-spacer>
        <v-btn
          icon
          color="white"
          @click="close()"
          :title="$t('Cancel')"
          id="btn-modal-cancel"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="mt-5 pb-0">
        <ng-auto
          label="Producto"
          v-model="selected_product"
          url="api/v1/list/products-actives"
          @change="consultProduct"
        ></ng-auto>
      </v-card-text>
      <!-- Product Detail -->
      <v-card-text v-if="product" >
        <v-card flat max-height="70vh" class="overflow-y-auto">
          <v-card-text>
            <v-row>
              <v-col cols="12" md="3" class="d-flex justify-center">
                <img
                  src="@/assets/product-blank.png"
                  v-show="!path"
                  style="width: fit-content"
                />
                <img
                  :src="path"
                  v-if="path != ''"
                  style="max-width: 165px; height: auto"
                />
              </v-col>
              <v-col cols="12" md="9">
                <v-row no-gutters>
                  <v-col>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>
                          <div
                            class="d-flex justify-space-between list-mobile-field"
                          >
                            <span class="title-td"
                              >{{ $t("product_type") }}:
                            </span>

                            <span
                              >{{ $filters.name(product.product_type) }}
                            </span>
                          </div>
                        </v-list-item-title>
                        <v-divider></v-divider>
                        <v-list-item-title>
                          <div
                            class="d-flex justify-space-between list-mobile-field"
                          >
                            <span class="title-td"
                              >{{ $t("reference") }}:
                            </span>

                            <span>{{ product.reference }} </span>
                          </div>
                        </v-list-item-title>
                        <v-divider></v-divider>
                        <v-list-item-title>
                          <div
                            class="d-flex justify-space-between list-mobile-field"
                          >
                            <span class="title-td">{{ $t("bar_code") }}: </span>

                            <span>{{ product.bar_code }} </span>
                          </div>
                        </v-list-item-title>
                        <v-divider></v-divider>
                        <v-list-item-title>
                          <div
                            class="d-flex justify-space-between list-mobile-field"
                          >
                            <span class="title-td"
                              >{{ $t("can_be_sold") }}:
                            </span>

                            <span
                              >{{ $filters.boolean(product.can_be_sold) }}
                            </span>
                          </div>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item></v-col
                  >
                  <v-col>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>
                          <div
                            class="d-flex justify-space-between list-mobile-field"
                          >
                            <span class="title-td">{{ $t("name") }}: </span>

                            <span>{{ product.name }} </span>
                          </div>
                        </v-list-item-title>
                        <v-divider></v-divider>
                        <v-list-item-title>
                          <div
                            class="d-flex justify-space-between list-mobile-field"
                          >
                            <span class="title-td">{{ $t("category") }}: </span>

                            <span>{{ $filters.name(product.category) }} </span>
                          </div>
                        </v-list-item-title>
                        <v-divider></v-divider>
                        <v-list-item-title>
                          <div
                            class="d-flex justify-space-between list-mobile-field"
                          >
                            <span class="title-td">{{ $t("unity") }}: </span>

                            <span> {{ $filters.name(product.unity) }}</span>
                          </div>
                        </v-list-item-title>
                        <template v-if="product.can_be_sold">
                          <v-divider></v-divider>
                          <v-list-item-title>
                            <div
                              class="d-flex justify-space-between list-mobile-field"
                            >
                              <span class="title-td">{{ $t("tax") }}: </span>

                              <span>{{ $filters.name(product.tax) }} </span>
                            </div>
                          </v-list-item-title>

                          <v-divider></v-divider>
                          <v-list-item-title>
                            <div
                              class="d-flex justify-space-between list-mobile-field"
                            >
                              <span class="title-td">{{ $t("price") }}: </span>

                              <span
                                >{{ $filters.currency(product.price) }}
                              </span>
                            </div>
                          </v-list-item-title>
                        </template>
                      </v-list-item-content>
                    </v-list-item></v-col
                  >
                </v-row>
              </v-col>
              <v-col cols="6"> </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col cols="12">
                <v-tabs
                  v-model="tab"
                  background-color="primary"
                  dark
                  show-arrows
                  centered
                >
                  <v-tabs-slider color="yellow"></v-tabs-slider>
                  <v-tab v-for="val in items" :key="val">
                    {{ $t(val) }}
                  </v-tab>
                </v-tabs>
                <v-tabs-items v-model="tab">
                  <v-tab-item>
                    <Stock :product_id="product_id" />
                  </v-tab-item>
                </v-tabs-items>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-text v-if="!product">
        <v-alert dense text type="info"
          >No se ha consultado ningún producto. Para buscar uno de clic en el
          botón de buscar.</v-alert
        >
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import Stock from "./consult_product_components/Stock.vue";
export default {
  data() {
    return {
      dialog: false,
      product_id: null,
      url_product: "api/v1/product",
      selected_product: null,
      path: "",
      product: null,
      tab: null,
      items: ["Existencias"],
    };
  },
  components: { Stock },
  methods: {
    renderItem() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    getPath() {
      if (this.product) {
        this.path = this.$filters.pathImage(this.product, "image");
      }
      return null;
    },
    consultProduct() {
      if (this.selected_product) {
        this.product_id = this.selected_product.id;
        this.product = null;
        this.getProduct();
      }
    },
    getProduct() {
      this.$http
        .get(this.url_product + "/" + this.product_id, true)
        .then((res) => {
          if (res.success) {
            this.product = res.item;
            this.getPath();
            console.log(this.product);
          }
        });
    },
  },
};
</script>